"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var ButtonWithModal_1 = __importDefault(require("atomicComponents/organisms/Button/ButtonWithModal"));
var ConnectionError_1 = __importDefault(require("containers/AssistedOnboarding/WelcomeFlow/ConnectionAlerts/ConnectionError"));
var analytics_1 = require("utils/analytics");
var HoCs_1 = require("utils/HoCs");
var hooks_1 = require("utils/hooks");
var AddConnectionModal_1 = __importDefault(require("./AddConnectionModal"));
var ConnectionSuccess_1 = __importDefault(require("./ConnectionSuccess"));
var NewPaymentsConnection_1 = __importDefault(require("./NewPaymentsConnection"));
var NewConnection = function () {
    var _a = __read((0, hooks_1.useSearch)('connected'), 2), successMessage = _a[0], setSuccessMessage = _a[1];
    var _b = __read((0, hooks_1.useSearch)('error'), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = __read(react_1.default.useState(false), 2), openModal = _c[0], setOpenModal = _c[1];
    var trackClick = (0, analytics_1.usePreparedTracker)('New Connection Clicked');
    var isPayments = (0, react_router_1.useRouteMatch)('/settings/integrations/payments');
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isPayments
                ? (0, jsx_runtime_1.jsx)(NewPaymentsConnection_1.default, {})
                : ((0, jsx_runtime_1.jsx)(ButtonWithModal_1.default, __assign({ modalComponent: AddConnectionModal_1.default, modalProps: { openModal: openModal }, openByDefault: !!openModal, onClose: function () { return setOpenModal(!openModal); }, onOpen: trackClick }, { children: "New Connection" }))), (0, jsx_runtime_1.jsx)(ConnectionSuccess_1.default, { open: !!successMessage, onClose: function () { return setSuccessMessage(''); } }), (0, jsx_runtime_1.jsx)(ConnectionError_1.default, { open: !!errorMessage, errorMessage: errorMessage, onClose: function () { return setErrorMessage(''); }, buttonAction: function () { return setErrorMessage(''); } })] }));
};
exports.default = (0, HoCs_1.HasCompanyHoC)(NewConnection);
